import { Classes, Dialog } from "@blueprintjs/core"
import { PlanrButton } from "modules/common/components/planr/button/Button"
import { GeneralIcon } from "modules/common/components/planr/icon/Generalcon"
import React from "react"
import { QuestionCardType } from "../models/card"
import styles from "./ReviewConfirmDialog.module.scss"

/**
 * Отправка на проверку за коллег: исполнителей несколько, а отметились не все.
 * Спрашиваем прямо, чтобы решение было осознанным
 */
export const ReviewConfirmDialog: React.FC<ReviewConfirmDialogProps> = ({ card, onConfirm, onCancel }) => {
  const waiting = card.implementers.length > 0 ? card.implementers : card.employers

  return (
    <Dialog
      isCloseButtonShown={true}
      isOpen={true}
      onClose={onCancel}
      title="Отправить на проверку"
      backdropClassName="standard"
      className={`figma-dialog ${styles.dialog}`}
    >
      <div className={styles.body}>
        <div className={styles.question} title={card.title}>
          <span className={styles.number}>{card.number}</span>
          {card.label}
        </div>

        <div className={styles.notice}>
          <GeneralIcon type="general-exclamation" size={16} />
          <span>
            Задание выполняют {card.executorsCount} чел., о готовности отметились {card.readyCount}.
            Отправив его сейчас, вы закрываете работу за всех.
          </span>
        </div>

        <div className={styles.people}>
          {waiting.map((person) => (
            <div className={styles.person} key={person.id}>
              {person.name}
            </div>
          ))}
        </div>
      </div>

      <div className={Classes.DIALOG_FOOTER}>
        <div className={styles.footer}>
          <PlanrButton type="greenish" onClick={onConfirm}>
            Отправить за всех
          </PlanrButton>
          <PlanrButton type="graybtn" onClick={onCancel}>
            Отмена
          </PlanrButton>
        </div>
      </div>
    </Dialog>
  )
}

interface ReviewConfirmDialogProps {
  card: QuestionCardType
  onConfirm: () => void
  onCancel: () => void
}
